import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 text-lg font-heading whitespace-nowrap cursor-pointer"
          >
            <span className={`font-bold transition-colors duration-300 ${isScrolled ? 'text-foreground-950' : 'text-background-50'}`}>
              草榴社区入口
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-500/15 text-primary-700 font-medium'
                  : isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-500/15 text-primary-700 font-medium'
                    : isScrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-500/15 text-primary-700 font-medium'
                  : isScrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-background-50/15'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              isScrolled
                ? 'text-foreground-700 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/15'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer whitespace-nowrap">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg cursor-pointer whitespace-nowrap">
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}